import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../../common/EditPage';
import Panel from '../../../../common/layout/Panel'
import { getOne, create } from './../../../../common/v4/BackendProvider';
import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const SmsRateCreate = () => {
     const [loading, setLoading] = useState(true);
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const [data, setData] = useState({
        'name': '',
        'description': '',
    });

    const handleSave = () => {
        create('/admin/products/sms/rates', {data: data})
            .then(response => {
                toast.success('SMS Rate Table created successfully');
                navigate(`/products/sms/rates`);
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    const handleCancel = () => {
        navigate('/products/sms/rates');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }
    
    return (<> 
        <Panel title = "SMS Rate">
            <div>
                <ToastContainer />
                <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create SMS Rate Table">
                    <EditPagePanel>
                        <EditPageTextField label="Name" nullable id="ATRNAME" onChange={ onChange } value={ data.ATRNAME } />
                        <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                   </EditPagePanel>
                </EditPage>
            </div>
        </Panel>
        </>
    )
}

export default SmsRateCreate;